import type { Security_SessionSummary } from 'invApi';

/**
 * Check if user needs to update their credentials
 *
 * Credentials update required if:
 * - ExpiredPassword = true (password has expired)
 * - TemporaryPassword = true (temporary password needs change)
 *
 * Note: This only applies to password-based authentication, not IDP/SSO
 */
export function isCredentialUpdateRequired(
  sessionSummary?: Security_SessionSummary
): boolean {
  return !!(
    sessionSummary?.ExpiredPassword || sessionSummary?.TemporaryPassword
  );
}
